import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BMS from '../views/BMS.vue'
// import Systems from '../views/Systems.vue'
// import Sensors from '../views/Sensors.vue'
// import Development from '../views/Development.vue'
import About from '../views/AboutView.vue'
import FAQ from '../views/FAQ.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home-view',
    component: HomeView
  },
  {
    path: '/bms',
    name: 'bms-view',
    component: BMS
  },
  // {
  //   path: '/systems',
  //   name: 'systems-view',
  //   component: Systems
  // },
  // {
  //   path: '/sensors',
  //   name: 'sensors-view',
  //   component: Sensors
  // },
  // {
  //   path: '/development',
  //   name: 'development-view',
  //   component: Development
  // },
  {
    path: '/about',
    name: 'about-view',
    component: About
  },
  {
    path: '/faq',
    name: 'FAQ-view',
    component: FAQ
  },
  // {
  //   path: '/about',
  //   name: 'about-view',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  routes
})


router.beforeEach((to, from, next) => {
  // console.log("Attempted route: ", to.path)
  // this shit happens on initial load, mostly on mobile
  if (
      to.path === null ||
      to.path === undefined ||
      to.path === false ||
      to.path === ''
  ) {
    // console.log('Undesired routing..')
    next('/')
  }
  // normal navigation
  else if (to.matched.some(record => record.meta)) {
    // console.log('Valid path..')
      next()
  } else {
    // console.log('Invalid path..')
    next('/')
  }
});



export default router
